/*
* Slider-Aufgabe:
* Definiert die v3s-input Direktive für die Slider-Aufgabe. <br>
* Die Direktive stellt das Slider-Element dar und zeigt den Auswertungsstatus an. <br>
* Eingebunden wird das noUiSlider-Objekt: https://refreshless.com/nouislider/
* @namespace v3sWbtPlayerApp:exercise:slider
* @param {string} v3s-orientation="horizontal" - Ausrichtung horizontal oder vertikal
* @param {number} v3s-start=0 - Startwert der Skala
* @param {number} v3s-end=12 - Skalen-Endwert
* @param {number} v3s-step=1 - Schrittweite des Handlers
* @param {string} v3s-visibility="block" - Anzeige der Skala: block / none
* @param {number} v3s-value - Gesuchte Antwort
* @param {number} v3s-tolerance - Toleranz nach oben und unten
* @param {string} v3s-fod - Feeback in der Endauswertung
* @example:
* <v3s-slider id="SL01" v3s-name="SR-Monate" v3s-left="50" v3s-top="200" v3s-width="400" v3s-height="50" v3s-visibility="block">
*     <v3s-scale v3s-orientation="horizontal" v3s-start="0" v3s-end="12" v3s-step="1" v3s-visibility="block"></v3s-scale>
*     <v3s-solution v3s-value="6" v3s-tolerance="0"></v3s-solution>
*     <v3s-fod>Feedback on Demand</v3s-fod>
*     <v3s-description>Beschreibung der Aufgabe ...</v3s-description>
* </v3s-slider>
*/

angular.module('v3sWbtPlayerApp').directive('v3sSlider', ["$tooltip", "v3sSliderElement", "v3sI18nService", 'v3sContentMediaPath',
    function ($tooltip, v3sSliderElement, v3sI18nService, v3sContentMediaPath) {
        return {
            restrict: 'EA',
            require: '^v3sDocument',
            scope: {
                id: '@',
                v3sHeight: '@',
                v3sWidth: '@',
                v3sLeft: '@',
                v3sTop: '@'
            },
            //  SOLL:
            //  template: '<input></input>', bzw.
            //  template: '<input type="range" ></input>',
            template: '<div data-clickable="true" v3s-clickable></div>',
            transclude: true,
            link: function (scope, element, attributes, v3sDocumentCtrl, transclude) {
                var tooltip;

                if (!!scope.id) {
                    v3sDocumentCtrl.addElement(element);
                }

                transclude(scope, function (clone, scope) {
                    angular.forEach(clone, function (node) {
                        var tagName = node.tagName.toLowerCase();
                        switch (tagName) {
                            case "v3s-scale":
                                scope.v3sOrientation = node.getAttribute("v3s-orientation");
                                scope.v3sStart = parseFloat(node.getAttribute("v3s-start"));
                                scope.v3sEnd = parseFloat(node.getAttribute("v3s-end"));
                                scope.v3sStep = parseFloat(node.getAttribute("v3s-step"));
                                scope.v3sVisibility = node.getAttribute("v3s-visibility");
                                break;
                            case "v3s-solution":
                                scope.v3sValue = node.getAttribute("v3s-value");
                                scope.v3sValMin = node.getAttribute("v3s-value-min");
                                scope.v3sValMax = node.getAttribute("v3s-value-max");
                                scope.v3sTolerance = node.getAttribute("v3s-tolerance");
                                break;
                            case "v3s-handle":
                                scope.v3sHandleWidth = parseFloat(node.getAttribute("v3s-width"));
                                scope.v3sHandleHeight = parseFloat(node.getAttribute("v3s-height"));
                                scope.v3sHandleFile = node.getAttribute("v3s-file");
                                break;
                            case "v3s-fod":
                                scope.fod = node.textContent;
                                break;
                            case "v3s-description":
                                var description = node.textContent;
                                break;
                            default:
                                debugger;
                        }
                    });
                });

                //  Pos-Array für Start und Lösung je nach Anzahl der Handler:
                var posCorrect = scope.v3sValue ? [scope.v3sValue] : [scope.v3sValMin, scope.v3sValMax],
                    posStart = scope.v3sValue ? [scope.v3sStart] : [scope.v3sStart, scope.v3sEnd],
                    direction = (scope.v3sOrientation === "horizontal") ? "ltr" : "rtl",
                    sliderElement = new v3sSliderElement(scope.id),
                    inputFeld = element.find("div")[0];

                //   SliderElementToolTip (= aktueller Werte) nur anzeigen, wenn die Skala eingeblendet ist!
                if (scope.v3sVisibility == "none") {
                    var sett = false;
                } else {
                    var sett = scope.v3sValue ? true : [true, true];
                }
                sliderElement.setAnswerTolerance(scope.v3sTolerance);
                sliderElement.setCorrectAnswer(posCorrect, direction);

                if (scope.v3sHandleFile) {
                    element[0].className += " img-slider";
                }

                //  ==============================================================================
                //   Einbinden des noUiSlider-Objekts als Handler
                //  ==============================================================================
                noUiSlider.create(inputFeld, {
                    start: posStart,
                    step: scope.v3sStep,
                    direction: direction,
                    orientation: scope.v3sOrientation,
                    tooltips: sett,
                    behaviour: 'none',
                    range: {
                        'min': scope.v3sStart,
                        'max': scope.v3sEnd
                    }
                });

                var slider = inputFeld.noUiSlider;
                var domBack, domHandle, domTTip, domOrigin, domBereich;

                //ggf. geladene Positions einnehmen
                if (sliderElement.userAnswer.length > 0) {
                    slider.set(angular.copy(sliderElement.userAnswer));
                    //Set Event von nouislider will nicht so richtig :(
                    angular.forEach(sliderElement.userAnswer, function (answer,$index) {
                        sliderElement.checkAnswer($index);
                    })
                }

                //  ==============================================================================
                //  Einbinden des noUiSlider-Objekts zum Anzeigen der richtigen LÖSUNG
                //  ==============================================================================
                element.append("<div class='noUi-solution'> </div>");
                var solutionSlide = element[0].getElementsByClassName("noUi-solution")[0];

                noUiSlider.create(solutionSlide, {
                    start: posCorrect,
                    step: scope.v3sStep,
                    connect: false,
                    direction: direction,
                    orientation: scope.v3sOrientation,
                    tooltips: false,
                    range: {
                        'min': scope.v3sStart,
                        'max': scope.v3sEnd
                    }
                });

                // Lösungs-Handler das richtige FORMAT zuweisen:
                var domSolutionHandle;
                for (var i = 0; i < sliderElement.getHandlerLength() ; i++) {
                    domSolutionHandle = solutionSlide.getElementsByClassName("noUi-handle")[i];
                    if (scope.v3sOrientation === "horizontal") {
                        domSolutionHandle.className += " fa noUi-solution-horizontal";
                    } else {
                        domSolutionHandle.className += " fa noUi-solution-vertical";
                    }
                }

                // Für Smartphone erforderlich:
                if (scope.v3sOrientation === "horizontal") {
                    solutionSlide.style.height = getHandleHeight() + "px";
                    solutionSlide.style.top = "-" + getHandleHeight() * 0.75 + "px";
                } else {
                    solutionSlide.style.height = scope.v3sHeight + "px";
                    solutionSlide.style.width = scope.v3sWidth + "px";
                    solutionSlide.style.top = "-" + scope.v3sHeight + "px";
                }
                solutionSlide.setAttribute('disabled', true);

                //  ==============================================================================
                //  Slider-Events:
                //  ==============================================================================
                slider.on('start', function (values, handle) {
                    var handleID = parseInt(handle);
                    var antagonist = handleID ? 0 : 1;

                    //  Vertikaler Bereich:
                    if (direction === "rtl" && scope.v3sValMin) {
                        domHandle = element[0].getElementsByClassName("noUi-handle")[antagonist];
                    }else{
                        domHandle = element[0].getElementsByClassName("noUi-handle")[handleID];
                    }

                    //  Tooltip verstecken:
                    if (tooltip) tooltip.hide();

                    //  Style für FALSCHE Lösung entfernen:
                    var ms;
                    if (scope.v3sHandleFile) {
                        ms = removeClass(domHandle, "handle-img-incorrect");
                    }else{
                        ms = removeClass(domHandle, "handle-incorrect");
                    }

                    //  Style für den Bereich entfernen:
                    if (scope.v3sValMax && scope.v3sVisibility === "block") {
                        domBereich = element[0].getElementsByClassName("noUi-origin")[0];
                        removeClass(domBereich, "area-incorrect");
                    }

                });

                slider.on('set', function (values, handle) {
                    sliderElement.setUserAnswer(values, handle);
                });

                //  ==============================================================================
                //  Höhe und Breite der Handler:
                //  ==============================================================================
                //  Breite des Slide-Handlers ermitteln und zurückgeben
                function getHandleWidth() {
                    var breite;
                    if (!scope.v3sHandleFile) {
                        if (scope.v3sOrientation === "horizontal") {
                            breite = scope.v3sHeight;
                        } else {
                            breite = scope.v3sWidth;
                        }
                    } else {
                        breite = scope.v3sHandleWidth;
                    }
                    return Math.round(breite)
                }

                //   Höhe des Slide-Handlers ermitteln und zurückgeben
                function getHandleHeight() {
                    var hohe;
                    if (!scope.v3sHandleFile) {
                        if (scope.v3sOrientation === "horizontal") {
                            hohe = scope.v3sHeight;
                        } else {
                            hohe = scope.v3sWidth;
                        }
                    } else {
                        hohe = scope.v3sHandleHeight;
                    }
                    return Math.round(hohe)
                }

                //  ==============================================================================
                //  Slide Handlern das richtige CSS zuweisen
                //  ==============================================================================
                function getHandlerStyle(id) {
                    var val;
                    //  HG-Bild vorhanden?
                    if (scope.v3sHandleFile) {
                        //  Pfad zum HG-Bild:
                        var domImg = 'url("./' + v3sContentMediaPath + scope.v3sHandleFile + '")';
                        domHandle.style.backgroundImage = domImg;
                        // Bei mehr als einem Slider HG-bild ggf. spiegeln:
                        if (sliderElement.getHandlerLength() === 1) {
                            val = ' handleImg';
                        } else {
                            if (scope.v3sOrientation === "horizontal") {
                                val = id ? ' handleImgRight' : ' handleImgLeft';    // 1=rechts, 0=links;
                            } else {
                                val = id ? ' handleImgBottom' : ' handleImgTop';     // 1=oben, 0=unten
                            }
                        }
                        //  Konstruiere Handler
                    } else {
                        if (sliderElement.getHandlerLength() === 1) {
                            val = ' handleConst';  // ein Handler -> rund
                        } else {
                            if (scope.v3sOrientation === "horizontal") {
                                val = id ? ' handleRight' : ' handleLeft';   // 0=links, 1=rechts;
                            } else {
                                val = id ? ' handleTop' : ' handleBottom';   // 1=Oben, 0=unten, ;
                            }
                        }
                    }
                    return val;
                }

                //  ==============================================================================
                //  Linke Position des Handlers:
                //  ==============================================================================
                function getHandlePosLeft(id) {
                    var links = 0;
                    if (scope.v3sOrientation === "horizontal") {
                        if (i === 1) {
                            links = 0;
                        } else {
                            if (scope.v3sHandleFile && sliderElement.getHandlerLength() === 2) {
                                links = "-" + getHandleWidth();
                            } else {
                                links = "-" + getHandleWidth() / 2;
                            }
                        }
                    } else {
                        links = -(getHandleWidth() - scope.v3sWidth / 2) / 2 - 1;
                    }
                    links = links + "px";
                    return links;
                }
                //  ==============================================================================
                //  Position des Handlers:
                //  ==============================================================================
                function getHandlePosTop(id) {
                    var oben = 0;
                    if (scope.v3sOrientation === "horizontal") {
                        oben = -(getHandleHeight() - scope.v3sHeight/2) / 2 - 1;
                    } else {
                        if (i === 1) {
                            oben = 0;
                        } else {
                            if (scope.v3sHandleFile && sliderElement.getHandlerLength() === 2) {
                                oben = "-" + getHandleHeight();
                            }else{
                                oben = "-" + getHandleHeight() / 2;
                            }
                        }
                    }
                    return oben + "px";
                }
                //  ==============================================================================
                //   RemoveClass auch für den IE 9
                //  ==============================================================================
                function removeClass(elem, cls) {
                    if (elem.classList) {
                        elem.classList.remove(cls);
                        return elem.classList
                    }else{
                        var elClass = elem.className;
                        while (elClass.indexOf(cls) != -1) {
                            elClass = elClass.replace(cls, '');
                            elClass = elClass.trim();
                        }
                        elem.className = elClass;
                        return elClass
                    }
                }

                //  ==============================================================================
                //  Jedem Handler die Styles zuweisen:
                //  ==============================================================================
                for (var i = 0; i < sliderElement.getHandlerLength() ; i++) {
                    domOrigin = element[0].getElementsByClassName("noUi-origin")[i];
                    domHandle = element[0].getElementsByClassName("noUi-handle")[i];
                    domBack = element[0].getElementsByClassName('noUi-target')[i];

                    //   Größe des Layers für den Slider-Hintergrunds anpassen:
                    if (scope.v3sOrientation === "horizontal") {
                        domBack.style.height = scope.v3sHeight / 2 + "px";    // Work-a-round für den  Slider bei Verkleinerung
                        domBack.className += ' noUi-target-horizontal';
                    } else {
                        domBack.style.height = scope.v3sHeight + "px";      // Work-a-round für den Slider bei Verkleinerung
                        domBack.className += ' noUi-target-vertikal';
                    }

                    //  ==================================================================
                    //  Größe des Slide-Handlers:
                    //  Bei Doppel-Handler halbieren!
                    if (sliderElement.getHandlerLength() === 1 || scope.v3sHandleFile) {
                        domHandle.style.width = getHandleWidth() + "px";
                        domHandle.style.height = getHandleHeight() + "px";
                    } else {
                        if (scope.v3sOrientation === "horizontal") {
                            domHandle.style.width = getHandleWidth() / 2 + "px";
                            domHandle.style.height = getHandleHeight() + "px";
                        } else {
                            domHandle.style.width = getHandleWidth() + "px";
                            domHandle.style.height = getHandleHeight() / 2 + "px";
                        }
                    }

                    //  Handler-Position (l,r,o,u):
                    domHandle.style.left = getHandlePosLeft(i) ;
                    domHandle.style.top = getHandlePosTop(i);

                    // Zuweisen des HG-Bild bzw. des Styles
                    domHandle.className += getHandlerStyle(i);  // Konstruktion: einfach, doppelt ...

                    // Anzeigen des Slider - Hintergrundes unterdrücken?
                    if (scope.v3sVisibility === "none") {
                        domBack.className += ' noUi-target-hidden';
                    }
                }

                //  ------------------------------------------------------------------------------
                //  Einfärben des Zielbereiches, wenn
                //  (1) Breichs-Aufgabe (2) Skala sichtbar
                if (scope.v3sValMax && scope.v3sVisibility === "block") {
                    element[0].getElementsByClassName("noUi-base")[0].className += " area-cover";
                    element[0].getElementsByClassName("noUi-origin")[0].className += " area-neutral";
                    element[0].getElementsByClassName("noUi-origin")[1].className += " area-cover";
                }

                //  ------------------------------------------------------------------------------
                //  Vertikaler Bereich -> Lösungsarray anpassen:
                //  ------------------------------------------------------------------------------
                if (direction == "rtl" && !scope.v3sValue) {
                    sliderElement.reverseArray();
                }

                //  ==============================================================================
                //   Feedback zuweisen
                //  ==============================================================================
                sliderElement.setShowFeedback(function () {

                    if (sliderElement.isFeedbackVisible()) {

                        var status = null;
                        var msg = "";

                        //  Nur ein Handler oder aber beide Handler einer Slider-Aufgabe bewegt
                        if (sliderElement.getHandlerLength() === 1 || sliderElement.showTooltip()) {
                            for (var i = 0; i < sliderElement.getHandlerLength() ; i++) {
                                var zahl
                                if (direction == "rtl" && !scope.v3sValue) {
                                    zahl = i ? 0 : 1;
                                } else {
                                    zahl = i;
                                }
                                var domHandle = element[0].getElementsByClassName("noUi-handle")[zahl];
                                var domOrigin = element[0].getElementsByClassName("noUi-origin")[zahl];
                                var solOrigin = solutionSlide.getElementsByClassName("noUi-origin")[zahl];


                                var richtig = sliderElement.isAnswerCorrect(i);
                                if (richtig) {
                                    if (scope.v3sHandleFile) {
                                        removeClass(domHandle, "handle-img-incorrect");
                                        domHandle.className += " handle-img-correct";
                                    } else {
                                        domHandle.className += " handle-correct";
                                    }
                                    domOrigin.setAttribute('disabled', true);
                                } else {
                                    if (scope.v3sHandleFile) {
                                        domHandle.className += " handle-img-incorrect";
                                    } else {
                                        domHandle.className += " handle-incorrect";
                                    }
                                }
                            }

                            // Tooltip: Slider nicht fertig
                            status = sliderElement.getStatus();
                            msg = "";
                            if (!sliderElement.completed) {
                                msg = v3sI18nService.getText([
                               "exercises.fod.input." + status.name,
                               "exercises.fod.general." + status.name
                                ]);
                                tooltip = $tooltip(element, { title: msg });
                            }
                        }

                        //  ----------------------------------------------------------
                        // Bereich einfärben?:
                        if (scope.v3sValMax) {
                            if (sliderElement.isAnswerCorrect(0) && sliderElement.isAnswerCorrect(1)) {
                                element[0].className += " area-correct";
                            } else {
                                element[0].className += " area-incorrect";
                            }
                        }

                        //  ----------------------------------------------------------
                        //  Wenn die komplette Aufgabe fertig:
                        if (sliderElement.completed) {

                            var status = sliderElement.getStatus(),
                               msg = "";

                            //  Tooltip anzeigen, wenn Slider fertig bearbeitet ist:
                            msg = v3sI18nService.getText([
                               "exercises.fod.input." + status.name,
                               "exercises.fod.general." + status.name
                            ]);
                            if (scope.fod) msg += " " + scope.fod;

                            tooltip = $tooltip(element, { title: msg });

                            //  Lösungs-Slider anzeigen:
                            solutionSlide.style.display = "block";
                        }
                    }

                    if (sliderElement.completed) {
                        inputFeld.setAttribute('disabled', true);
                    }
                });
            }
        }
    }]);